export const getStyles = (darkMode) => ({
    container: {
      maxWidth: 1400,
      margin: "0 auto",
      padding: "12px",
      backgroundColor: darkMode ? "#141414" : "#f0f2f5",
      minHeight: "100vh",
      transition: "all 0.3s ease",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 12,
    },
    headerTitle: {
      margin: 0,
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : "#1a1a1a",
    },
    headerActions: {
      display: "flex",
      gap: 8,
      alignItems: "center",
    },
    card: {
      borderRadius: 8,
      marginBottom: 10,
      backgroundColor: darkMode ? "#1f1f1f" : "#fff",
      borderColor: darkMode ? "#303030" : "#f0f0f0",
    },
    cardTitle: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    sectionTitle: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
      marginBottom: 10,
    },
    textColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    secondaryTextColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)",
    },
    actionButton: {
      height: "auto",
      padding: "12px 8px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    badgeIcon: {
      fontSize: 20,
      color: darkMode ? "rgba(255, 255, 255, 0.65)" : undefined,
    },
    listItem: {
      padding: "8px 0",
      borderBottom: `1px solid ${darkMode ? "#303030" : "#f0f0f0"}`,
    },
    avatarIcon: {
      backgroundColor: darkMode ? "#2a2a2a" : "#f0f0f0",
      color: darkMode ? "#ffffff" : "#1890ff",
    },
    trainingCard: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
  });